import { Button } from '@magnetic/button';
import { Container, Flex, Heading } from '@magnetic/core';
import { Text } from "@magnetic/text";
import { Application } from '../../../helpers/models';
import React from 'react';

type TestingInfoProps = {
  application: Application;
}

const TestingInfo = ({ application }: TestingInfoProps) => {
  // Parse redirect URIs from the string (can be space or newline separated)
  const redirectUris = application.redirectUris
    .split(/[\s\n]+/)
    .filter(Boolean);

  const buildAuthorizeUrl = (redirectUri: string): string => {
    const params = new URLSearchParams({
      client_id: application.uid,
      redirect_uri: redirectUri,
      scope: application.scopes.join(' '),
      response_type: 'code'
    });
    
    return `/oauth/authorize?${params.toString()}`;
  };

  return (
    <Container style={{ marginBottom: '30px' }}>
      <Heading size="section">Testing</Heading>
      <Text size="p2" color='light' style={{ marginBottom: "20px" }}>
        Test OAuth authorization flows with your configured redirect URIs
      </Text>
      <Container.Divider />
      
      {redirectUris.length === 0 ? (
        <Flex direction="vertical" style={{ padding: '20px 0' }}>
          <Text color='light'>No redirect URIs configured. Add redirect URIs in the Basic Info tab to test authorization flows.</Text>
        </Flex>
      ) : (
        redirectUris.map((uri, index) => (
          <React.Fragment key={index}>
            <Flex gap='sm' align='center' style={{ padding: '20px 0' }}>
              <Button 
                as="a"
                href={buildAuthorizeUrl(uri)}
                target="_blank"
                rel="noopener noreferrer"
                kind="primary"
              >
                Authorize
              </Button>
              <Flex direction="vertical" style={{ flex: 1, minWidth: 0 }}>
                <Text style={{ wordBreak: 'break-all' }}>{uri}</Text>
              </Flex>
            </Flex>
            {index < redirectUris.length - 1 && <Container.Divider />}
          </React.Fragment>
        ))
      )}
    </Container>
  );
};

export default TestingInfo;
